import React from "react";
import { Car, Heart, Home, Shield, Briefcase, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

const SERVICES = [
  {
    icon: Car,
    title: "Ubezpieczenia komunikacyjne",
    desc: "OC, AC, assistance i ubezpieczenia dla kierowców. Porównujemy oferty kilkunastu towarzystw, by wybrać najkorzystniejszą.",
  },
  {
    icon: Heart,
    title: "Ubezpieczenia majątkowe",
    desc: "Domy, mieszkania, budynki gospodarcze oraz wyposażenie chronione przed skutkami zdarzeń losowych.",
  },
  {
    icon: Home,
    title: "Ubezpieczenia na życie i zdrowie",
    desc: "Zabezpieczenie finansowe dla Ciebie i Twoich najbliższych w najtrudniejszych momentach.",
  },
  {
    icon: Shield,
    title: "Ubezpieczenia NNW",
    desc: "Ochrona dla dzieci, dorosłych oraz całych rodzin na wypadek nieszczęśliwych zdarzeń.",
  },
  {
    icon: Briefcase,
    title: "Ubezpieczenia firmowe",
    desc: "Rozwiązania dla przedsiębiorców, właścicieli firm i osób prowadzących działalność gospodarczą.",
  },
];

export const Services = () => {
  return (
    <section
      id="uslugi"
      data-testid="services-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="container-narrow">
        <Reveal>
          <div className="max-w-2xl">
            <div className="text-mustard-dark font-heading font-bold uppercase text-sm tracking-wider mb-3">
              Oferta
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-forest leading-tight">
              Wszystkie ubezpieczenia w jednym miejscu.
            </h2>
            <p className="mt-5 text-ink-muted text-lg leading-relaxed">
              Współpracujemy z ponad 25 największymi Towarzystwami Ubezpieczeniowymi
              w Polsce. Dzięki temu nie jesteśmy ograniczeni do jednej oferty.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={i * 60}>
                <a
                  href="#kontakt"
                  data-testid={`service-card-${i}`}
                  className="group block bg-cream rounded-2xl p-6 md:p-7 border border-bordersoft hover:border-forest/30 hover:-translate-y-1 transition-all duration-300 h-full"
                >
                  <div className="w-12 h-12 rounded-xl bg-white border border-bordersoft flex items-center justify-center mb-5 group-hover:bg-mustard/10 group-hover:border-mustard/30 transition-colors">
                    <Icon size={24} className="text-mustard-dark" strokeWidth={2} />
                  </div>
                  <h3 className="font-heading font-semibold text-forest text-xl mb-3">
                    {s.title}
                  </h3>
                  <p className="text-ink-muted text-base leading-relaxed mb-5">
                    {s.desc}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-forest font-semibold text-sm group-hover:gap-2.5 transition-all">
                    Zapytaj o tę ofertę
                    <ArrowRight size={16} strokeWidth={2.4} />
                  </span>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
